import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Crown, Plus, Save, Trash2 } from "lucide-react";

const newTier = () => ({ id: crypto.randomUUID(), tier_name: "", threshold_amount: 0, discount_percent: 0 });

export default function VipSettingsPage() {
    const [tiers, setTiers] = useState([]);
    const [initial, setInitial] = useState("[]");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/admin/vip-settings").then(({ data }) => {
            const loaded = data.tiers || [];
            setTiers(loaded);
            setInitial(JSON.stringify(loaded));
        }).catch(() => toast.error("会员等级加载失败"));
    }, []);

    const update = (index, patch) => setTiers((current) => current.map((tier, position) => (
        position === index ? { ...tier, ...patch } : tier
    )));
    const save = async () => {
        setSaving(true);
        try {
            const { data } = await api.put("/admin/vip-settings", { tiers });
            setTiers(data.tiers);
            setInitial(JSON.stringify(data.tiers));
            toast.success("会员等级已保存");
        } catch (error) {
            toast.error(error.response?.data?.detail || "会员等级保存失败");
        } finally {
            setSaving(false);
        }
    };
    const dirty = JSON.stringify(tiers) !== initial;

    return (
        <div className="space-y-6" data-testid="vip-settings-page">
            <div>
                <div className="text-xs font-semibold uppercase tracking-widest text-gold-500">会员制度</div>
                <h1 className="mt-1 text-3xl font-bold text-slate-900">VIP 会员等级</h1>
                <p className="mt-1 text-sm text-gold-600">按付款完成后的累计消费自动升级与打折。</p>
            </div>
            <Card className="space-y-4 border-slate-200 p-6 shadow-sm">
                {tiers.length === 0 && <p className="py-8 text-center text-sm text-slate-500">尚未设定等级，新增后才会开始计算会员折扣。</p>}
                {tiers.length > 0 && <div className="hidden gap-3 text-xs font-semibold text-gold-600 md:grid md:grid-cols-[1fr_10rem_9rem_auto]"><span>等级名称</span><span>累计消费门槛（RM）</span><span>折扣（%）</span><span>操作</span></div>}
                {tiers.map((tier, index) => (
                    <div key={tier.id} className="grid gap-3 border-b border-slate-100 pb-4 md:grid-cols-[1fr_10rem_9rem_auto]">
                        <Input data-testid={`vip-tier-name-${tier.id}`} value={tier.tier_name} placeholder="等级名称" onChange={(e) => update(index, { tier_name: e.target.value })} />
                        <Input data-testid={`vip-tier-threshold-${tier.id}`} type="number" min="0" value={tier.threshold_amount} aria-label="累计消费门槛" onChange={(e) => update(index, { threshold_amount: Number(e.target.value) || 0 })} />
                        <Input data-testid={`vip-tier-discount-${tier.id}`} type="number" min="0" max="100" value={tier.discount_percent} aria-label="折扣百分比" onChange={(e) => update(index, { discount_percent: Number(e.target.value) || 0 })} />
                        <Button type="button" variant="ghost" data-testid={`vip-tier-delete-${tier.id}`} onClick={() => setTiers((current) => current.filter((_, p) => p !== index))}><Trash2 className="h-4 w-4 text-red-600" /></Button>
                    </div>
                ))}
                <Button type="button" variant="outline" data-testid="vip-tier-add-button" onClick={() => setTiers((current) => [...current, newTier()])}><Plus className="mr-1 h-4 w-4" />新增等级</Button>
                <Button type="button" data-testid="vip-tier-save-button" disabled={!dirty || saving} onClick={save} className="ml-2 bg-gold-600 text-white hover:bg-gold-700"><Save className="mr-1 h-4 w-4" />{saving ? "保存中..." : "保存等级"}</Button>
            </Card>
        </div>
    );
}